import { Switch } from '@mui/material'
import {
  SettingItem,
  SettingLabel,
  SettingToggle,
} from './RoomViewSettingsItem.styles'
import { TRoomViewSettingsItemProps } from './RoomViewSettingsItem.types'

const RoomViewSettingsItem: React.FC<TRoomViewSettingsItemProps> = (props) => {
  const { onChange, label, value, disabled = false } = props

  return (
    <SettingItem>
      <SettingLabel>{label}</SettingLabel>
      <SettingToggle
        control={
          <Switch
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            color="primary"
          />
        }
        label=""
      />
    </SettingItem>
  )
}

export default RoomViewSettingsItem
